// client/plugins/handleTransactionMetaPlugin.ts
import { Plugin, PluginKey } from "prosemirror-state";
var handleTransactionMetaPlugin = (key, handler) => new Plugin({
  key: new PluginKey(key),
  filterTransaction: (_, state) => {
    handler(state.tr.getMeta(key));
    return true;
  }
});
export {
  handleTransactionMetaPlugin
};
